// Cookie-consent state. 'all' enables Google Analytics; 'essential' keeps
// only what sign-in needs (Firebase Auth). GA never initializes until
// consent is 'all' (see src/firebase.js), so "essential only" means no
// _ga cookies are ever set.

const ACK_KEY = 'tastr_cookie_ack'; // legacy flag from the disclosure-only banner
const CONSENT_KEY = 'tastr_cookie_consent'; // 'all' | 'essential'

export function getConsent() {
  try {
    const value = localStorage.getItem(CONSENT_KEY);
    if (value === 'all' || value === 'essential') return value;
    // Legacy "Got it" dismissals predate the choice; that banner's copy was
    // agree-by-use, so carry those users forward as having accepted all.
    if (localStorage.getItem(ACK_KEY) === '1') return 'all';
  } catch (_) {
    /* storage unavailable -> treat as undecided */
  }
  return null;
}

export function setConsent(value) {
  try {
    localStorage.setItem(CONSENT_KEY, value);
    localStorage.removeItem(ACK_KEY);
  } catch (_) {}
  if (value === 'essential') clearAnalyticsCookies();
}

// Best-effort removal of any GA cookies set before the user chose
// essential-only (GA was unconditional prior to the consent banner).
function clearAnalyticsCookies() {
  try {
    const names = document.cookie
      .split(';')
      .map((c) => c.split('=')[0].trim())
      .filter((name) => name.startsWith('_ga'));
    const domains = ['', window.location.hostname, `.${window.location.hostname}`];
    for (const name of names) {
      for (const domain of domains) {
        document.cookie =
          `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/` +
          (domain ? `; domain=${domain}` : '');
      }
    }
  } catch (_) {}
}
